import { useState } from 'react';
// import NSV1 from '../../Assets/Home/NSV1.png'

import Mounted1 from '../../Assets/Home/Mounted1.png'
import labvecial from '../../Assets/Home/labvecial.jpeg'
import NABL1 from '../../Assets/Home/NABL1.png'
import Bridge1 from '../../Assets/Home/Bridge1.png'
import LabDetails from './LabDetails';
import Labandmachinery from '../../Assets/Home/Hero/Labandmachineryvideo.mp4'
import LDD1 from '../../Assets/Home/LDD1.png'

const NewLabTesting = () => {
    const [toggleState, setToggleState] = useState("Laser Dynamic Deflectometer")

    const data = [
        {
            name: "Laser Dynamic Deflectometer",
            heading1: "Laser Dynamic Deflectometer",
            points2: ["Multi-Functional Platform", "High-Speed Continuous Assessment", "Continuous Weak-Section Detection", "Safer & Non-Disruptive Surveying", "Cost-Effective Network-Level Solution"],
            img1: LDD1,
            text1: "Multi-Functional Platform",
            text2: "High-Speed Continuous Assessment",
            text3: "Continuous Weak-Section Detection",
            text4: "Safer & Non-Disruptive Surveying",
            text5: "Cost-Effective Network-Level Solution",
        },
        {
            name: "Network Survey Vehicle",
            heading1: "Network Survey Vehicle",
            heading2: "Data Collected by Survey Vehicle (NSV)",
            points2: ["Road Roughness (Iri)", " Macrotexture And Longitudinal Profile", " Road Geometry", "Rut Depth, Width And Cross Sectional Area", " Curb/Drop Off Detection, ", " Pavement Images Automatically Overlaid With Defects", "Location Referencing & GPS", " Cross Slope/Fall(%)", " Gradient (%)", " Radius of Curvature (M)", " High Accuracy Distance/chainage", " Right Of Way (Row) Imagery(Assets)", " Pavement View Imagery (Condition)", "Road Inventory", "pavement Surface Defect"],
            img1: labvecial,
            text1: "Laser Profilometer DGPS",
            text2: "Laser Crack Measurement System (LCMS)",
            text3: "ROW Camera PAVE Camera",
            text4: "HRDMI (High Resolution Odometer)",
            text5: "Road Geometry",

        },
        {
            name: "Vehcile Mounted Failling Weight Deflectometer",
            heading1: "Specification",
            // points1: ["Vehicle Mounted versions with 7 Sensors", "Time history of load and deflection", "Automatic surface IR-thermometer and air thermometer", "Automatic distance meter"],
            heading2: "Load Pulse",
            points2: ["Peak load range: 10 - 150 KN", "Rise time: 12 ms-15", "Number of drop heights: 4", "4 Segments With Individual Tilt and Individual Vertical Movement", "300 mm diameter", "Carried Load: 450KN"],
            heading3: "Loading Plate",
            points3: ["Type: 4 segments with individual tilt and individual vertical movement", "Size: 300 mm diameter", "Rubber under plate: 32 mm ribbed"],
            img1: Mounted1,
            text1: "Rapid Data Collection",
            text2: "Minimized Traffic Disruption",
            text3: "Accurate Structural Evaluation",
            text4: "Real-Time Monitoring",
            text5: "Versatile Application",
        },
        {
            name: "NABL Accredited Lab",
            heading1: "Saptagon Lab Services, a division of Saptagon(formerly known as G-Eng), is a premier providerof laboratory testing and analytical services for theconstruction and engineering sectors. Ouradvanced facilities and skilled professionalsensure the highest standards of quality andreliability in every test we perform. At Saptagon,we believe that the future of [Field/Discipline] isshaped by relentless curiosity, groundbreakingresearch, and unwavering dedication. Nestled atthe intersection of innovation and expertise, ourlab is a beacon for transformative research andcutting-edge technology.",
            points2: ["Mix Design", " Soil-Rock & Flyash/Pond Ash Bentonite", "Reinforcement Steel Tmt Bar", "Aggregate", "Cement Concrete Testing", " Paver Block & Bricks Testing", "Bitumen, Bituminous Mix & Emulsion",],
            img1: NABL1,
            // img2: NABL2,
            text1: "Quality Assurance",
            text2: "International Recognition",
            text3: "Competence and Consistency",
            text4: "Enhanced Customer Trust",
            text5: "Continuous Improvement",
        },
        {
            name: "Mobile Bridge Inspection Unit (MBIU)",
            points1: ["16 M Boom, with Lowering Depth up to 21.7M", "Bucket Type with Load Capacity of 280 KG", "Safest on the Planet", "2 Rotations with 0-90° and 0-180°", "Walk System (Vehicle Move with Remote Control)", "Spare Power with DG Set", "Completely Remote Control System", "Cylindrical Stabilizer"],
            points2: ["16 m Boom, with lowering depth up to 21.7 m", " Bucket type with load capacity of 280 kg", " Safest on the planet", "2 rotations with 0-90° and 0-180°", "Walk system (vehicle move with remote control)", " Spare power with dg set", "Completely remote control system", " Cylindrical stabilizer"],
            img1: Bridge1,
            // img2: Bridge2,
            text1: "Comprehensive Inspection Capabilities",
            text2: "Mobility and Accessibility:",
            text3: "Real-Time Data Collection",
            text4: "Cost-Effective Solution",
            text5: "Improved Safety",
        },
    ]

    const renderComponent = () => {
        const selectedData = data.find(item => item.name === toggleState);
        if (!selectedData) return <div className='flex items-center justify-center text-center'><p>No Data Found! Try Again in Sometime.</p></div>;

        switch (toggleState) {
            case "Laser Dynamic Deflectometer":
    return <LabDetails data={selectedData} />;
            case "Network Survey Vehicle":
                return <LabDetails data={selectedData} />;
            case "Vehcile Mounted Failling Weight Deflectometer":
                return <LabDetails data={selectedData} />;
            case "Mobile Bridge Inspection Unit (MBIU)":
                return <LabDetails data={selectedData} />;
            case "NABL Accredited Lab":
                return <LabDetails data={selectedData} />;
            default:
                return null;
        }
    };

    return (
        <div className='flex flex-col items-center px-0 md:px-14 '>


            <div className='relative flex flex-col items-center justify-center gap-4 mb-10 w-full min-h-[26dvh] md:min-h-[65dvh] overflow-hidden' style={{ margin: "95px 0 0 0" }}>
                {/* Video Background */}
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className='absolute top-0 left-0 w-full h-full object-cover'
                    style={{ zIndex: 0 }}
                >
                    <source src={Labandmachinery} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                {/* Overlay */}
                <div className='absolute w-full h-full bg-[rgba(0,0,0,0.12)] backdrop-blur-[1px] rounded-xl' style={{ zIndex: 1 }}></div>

                {/* Content */}
                <div className='relative flex flex-col items-center justify-center gap-4 w-full min-h-[26dvh] md:min-h-[35dvh] px-4' style={{ zIndex: 2 }}>
                    <p className='text-white text-3xl md:text-4xl font-semibold'>Lab & Machinery</p>
                    <p className='text-white text-md md:text-lg tracking-wide'>Cutting-Edge In-House Equipment</p>
                    <p className='text-white text-2xl md:text-3xl text-center font-semibold'>{toggleState}</p>
                </div>
            </div>
            <div className="w-full flex flex-col items-center">
                {/* Tabs Section */}
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4 px-4 md:px-14">
    {data.map((item, i) => (
        <div
            key={i}
            className="flex items-center justify-center mt-6 md:mt-10"
        >
            <button
                className={
                    toggleState === item.name
                        ? "lab-tabs2 lab-active-tabs2 w-full h-16 sm:h-28 px-6 md:px-8 transition-transform duration-300 text-sm md:text-base"
                        : "lab-tabs2 w-full h-16 sm:h-28 px-6 md:px-8 transition-transform duration-300 hover:scale-110 hover:bg-[#8364c3] hover:text-white text-sm md:text-base"
                }
                onClick={() => setToggleState(item.name)}
            >
                {item.name}
            </button>
        </div>
    ))}
</div>

                {/* Content Section */}
                <div className="w-full flex flex-col items-center justify-center pt-8 md:pt-12">
                    {renderComponent()}
                </div>
            </div>

        </div>
    )
}

export default NewLabTesting